import { authData401, unsetAuthData } from 'app/slice/authSlice';

import store from 'app/store';
import axios from 'axios';
import { VI_LANG } from 'constants/global';
import { routerMain } from 'constants/routerMain';
import getMessage403 from 'helpers/error/getMessage403';
import getMessageError from 'helpers/error/getMessageError';
import getSystem from 'helpers/getSystem';
import { loading } from 'helpers/loading/Loading';
import queryString from 'query-string';
import { getOidcAccessToken, logoutOidc, refreshOidcToken } from 'oidc';
import getMessage401 from 'helpers/error/getMessage401';

const windowEnvConfig = window['runConfig'];

// Set up default config for http requests here
// Please have a look at here `https://github.com/axios/axios#request- config` for the full list of configs

const axiosClientNotTimeout = axios.create({
    baseURL: windowEnvConfig.REACT_APP_BASE_API_URL,
    headers: {
        'content-type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    },

    paramsSerializer: (params) => queryString.stringify(params),
});

axiosClientNotTimeout.interceptors.request.use(async (config) => {
    const local = localStorage.getItem('locale') || VI_LANG;

    const token = await getOidcAccessToken();
    loading.runLoadingBlockUI();

    config.headers.lang = local;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers.system = getSystem();

    return config;
});

axiosClientNotTimeout.interceptors.response.use(
    (response) => {
        loading.stopRunLoading();
        if (response?.data) {
            return response.data;
        }
        loading.stopRunLoading();

        return response;
    },
    async (error) => {
        // Handle errors
        loading.stopRunLoading();
        const local = localStorage.getItem('locale') || VI_LANG;

        const response = error.response;
        if (response && response.status === 401) {
            const isPermissionError = response?.data?.type === 2;
            const originalConfig = error.config;
            if (originalConfig && !originalConfig._retry && !isPermissionError) {
                originalConfig._retry = true;
                const newToken = await refreshOidcToken();
                if (newToken) {
                    originalConfig.headers.Authorization = `Bearer ${newToken}`;
                    return axiosClientNotTimeout(originalConfig);
                }
            }

            if (response?.data?.status === 401) {
                // if (response?.data?.type === 2) {
                //     store.dispatch(authData401({ message: response?.data?.message ?? error.message }));
                //     if (window.location.pathname !== routerMain.PAGE_401) {
                //         localStorage.setItem('historyUrl', window.location.pathname);
                //         window.location = routerMain.PAGE_401;
                //     }
                //     return;
                // }

                getMessage401(local, response?.data?.message ?? error.message);

                return;
            }
            store.dispatch(unsetAuthData());
            logoutOidc();
            return;
        }
        if (response && response.status === 403) {
            getMessage403(local);
            return;
        }
        getMessageError(local, error.message);

        throw error;
    }
);

export default axiosClientNotTimeout;
